import { useState } from "react";
import EventoFinalizarController from "../../../../components/evento-finalizar/evento-finalizar.controller";
import EventoContribuicaoFormController, {
  ETAPAS_COM_ANEXO,
  ETAPAS_EDICAO_COM_ANEXO,
  ETAPAS_EDICAO_SEM_ANEXO,
  ETAPAS_SEM_ANEXO,
  SalvamentoEtapaKey,
} from "../controller/evento-contribuicao-form.controller";

interface Params {
  controller: EventoContribuicaoFormController;
  eventoFinalizadorController: EventoFinalizarController;
  temAnexo: boolean;
  temAlteracaoAnexo: boolean;
}

export default function useSalvamentoContribuicao({
  controller,
  eventoFinalizadorController,
  temAnexo,
  temAlteracaoAnexo,
}: Params) {
  const [salvando, setSalvando] = useState(false);
  const [etapaAtual, setEtapaAtual] = useState<SalvamentoEtapaKey | null>(null);
  const [sucesso, setSucesso] = useState(false);
  const [protocoloSucesso, setProtocoloSucesso] = useState("");

  const isEdit = controller.isEdit;
  const etapasSalvamento = isEdit
    ? temAlteracaoAnexo
      ? ETAPAS_EDICAO_COM_ANEXO
      : ETAPAS_EDICAO_SEM_ANEXO
    : temAnexo
    ? ETAPAS_COM_ANEXO
    : ETAPAS_SEM_ANEXO;

  const handleConfirmSalvar = async (noMoreMessage: boolean) => {
    const dispositivo = controller.dispostivo;
    if (noMoreMessage) {
      dispositivo.setStExibirDialogoContribuicao(false);
      localStorage.setItem("ocultarDialogoContribuicao", "true");
    }
    setSucesso(false);
    setSalvando(true);
    setEtapaAtual("salvando");
    try {
      const result = await controller.executarFluxoSalvamento({
        ocultarDialogSalvar: noMoreMessage,
        onEtapaChange: setEtapaAtual,
        finalizar: () =>
          eventoFinalizadorController.finalizarNext(
            eventoFinalizadorController.satisfacaoResposta,
            controller.evento,
            controller,
            { skipBlockUI: true, skipToast: true, skipNavegacao: true }
          ),
      });
      setProtocoloSucesso(result?.protocolo ?? "");
      setSucesso(true);
    } catch {
      setSalvando(false);
      setEtapaAtual(null);
    }
  };

  const handleSalvarEdicao = async () => {
    setSucesso(false);
    setSalvando(true);
    setEtapaAtual("salvando");
    try {
      const result = await controller.executarFluxoEdicao({
        onEtapaChange: setEtapaAtual,
      });
      setProtocoloSucesso(result?.protocolo ?? "");
      setSucesso(true);
    } catch {
      setSalvando(false);
      setEtapaAtual(null);
    }
  };

  const handleFecharOverlay = () => {
    setSalvando(false);
    setSucesso(false);
    setEtapaAtual(null);
    if (isEdit) {
      controller.history.push(controller.location.state.rollBackUrl, {
        id: controller.location.state.idEvento,
      });
    } else {
      controller.proximaContribuicao();
    }
  };

  return {
    salvando,
    etapaAtual,
    sucesso,
    protocoloSucesso,
    etapasSalvamento,
    isEdit,
    exibirAvisoEmail: !isEdit,
    handleConfirmSalvar,
    handleSalvarEdicao,
    handleFecharOverlay,
  };
}
